import { Tooltip } from '@mui/material'
import { useAuth } from 'hooks/useAuth'
import { useStore } from 'hooks/useStore'

export function ImpersonatedBadge() {
	const { user } = useStore()
	const { impersonateMode } = useAuth()

	return (
		<>
			{impersonateMode && (
				<Tooltip
					classes={{ popper: 'custom-react-tooltip-mui' }}
					placement="bottom"
					title={
						<div className="flex-auto overflow-hidden rounded-2xl bg-primary-surface/[0.4] backdrop-blur-lg text-sm leading-6 shadow-lg ring-1 ring-white/10 flex flex-col items-center justify-center gap-2 p-4">
							<div className="flex flex-col gap-1">
								<span>{user?.name}</span>
								<span className="text-xs">{user?.userName}</span>
								<span className="text-xs">{user?.emailAddress}</span>
							</div>
						</div>
					}
				>
					<div className="fixed top-0 right-1 text-xs font-bold px-2 rounded-b transition-all duration-300 bg-primary h-[25px] flex justify-center items-center z-20">
						Impersonated
					</div>
				</Tooltip>
			)}
		</>
	)
}
